import React from 'react';

const MyItems = () => {
    return (
        <div>
            <h2 className='text-center mt-4'>This is My Items</h2>
        </div>
    );
};

export default MyItems;